import _ from 'lodash'
import {
  cachedConnect as connect,
} from './helpersHOC'
import Dashboard from '../components/Dashboard'

import { normalizeMinions, normalizeJobs } from '../saltapi/commonUtils'

export default connect((state, props, { cachedState }) => {
  console.log('C(Dashboard) before', cachedState, state, props)
  let changed = false
  let { _minions, _keys:keys, _jobs } = state.api
  let size = _.size(_minions)
  let {
    minions:acceptedKeys,
    minions_pre:pendingKeys,
    minions_rejected, minions_denied
  } = keys

  let jobs = normalizeJobs(_jobs)

  let minions = normalizeMinions(_minions, keys)

  let accepted = _.size(acceptedKeys)
  let pending = _.size(pendingKeys)
  let refused = _.size(minions_rejected) + _.size(minions_denied)

  if (!changed &&
      _.size(cachedState.minions) !== size)
    changed = true

  if (!changed &&
      _
        .chain(cachedState.minions)
        .filter('status')
        .size().value() !== _
          .chain(minions)
          .filter('status')
          .size().value())
    changed = true

  if(!changed &&
     (cachedState.accepted !== accepted ||
      cachedState.pending !== pending ||
      cachedState.refused !== refused))
    changed = true

  if(!changed &&
     (_.size(cachedState.jobs) !== _.size(jobs)))
    changed = true

  if (changed)
    cachedState = {
      minions, accepted, pending, refused, jobs
    }
  console.log('C(Dashboard) changed?', changed)
  console.log('C(Dashboard) ', cachedState, state, props)
  return cachedState
})(Dashboard)



// WEBPACK FOOTER //
// ./src/containers/Dashboard.js